var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.inhabitantChange)?_c('div',[_c('v-badge',{attrs:{"inline":"","color":"red","content":_vm.inhabitantChange}},[_vm._v(_vm._s(_vm.text))])],1):_c('div',[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }